// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2VumH","tab":"ProcedureTabs_tab__C3aTA"};